import api from './api';
import { loginOneSignal, logoutOneSignal, setOneSignalTags } from './onesignalService';

export const authService = {
  login: async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    if (response.success && response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      // BUG 19.4 (Phase 7.4, Jul 2026) — persist refresh token so the
      // axios interceptor in services/api.js can transparently rotate
      // an expired access token without bouncing the user to /login.
      // Falls back silently if the server response omits these fields
      // (e.g. running against a pre-7.2 backend).
      if (response.data.refreshToken) {
        localStorage.setItem('refresh_token', response.data.refreshToken);
      }
      if (response.data.refreshExpiresAt) {
        localStorage.setItem('refresh_expires_at', response.data.refreshExpiresAt);
      }
      // Phase 4 hot-fix #3 (Jul 2026) — tell the realtimeSocket
      // singleton that auth context is now available, so it can
      // (re)emit `join-admin {companyId}` even if the socket
      // connected before login completed. Same-tab event; the
      // `'storage'` listener already handles cross-tab.
      try { window.dispatchEvent(new Event('user-logged-in')); } catch {}
      // Register with OneSignal as admin
      loginOneSignal('admin');
      setOneSignalTags({ role: 'admin' });
    }
    return response;
  },

  logout: async () => {
    logoutOneSignal();
    // BUG 19.4 — best-effort server-side refresh-token revocation.
    // Fire-and-forget; logout must complete client-side even if the
    // server is unreachable.
    try {
      const rt = localStorage.getItem('refresh_token');
      if (rt) {
        await api.post('/auth/logout', { refreshToken: rt });
      }
    } catch (_) { /* ignore */ }
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('refresh_expires_at');
    window.location.href = '/login';
  },

  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  }
};
